var render = function render(){var _vm=this,_c=_vm._self._c;return _c('titled-card',{attrs:{"title":_vm.title,"count":_vm.incomes.length,"icon":"mdi-currency-usd"}},[_c('incomes-list',{attrs:{"incomes":_vm.incomes,"riskFileId":_vm.riskFileId,"isApproved":_vm.getRiskFileIsApproved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }